export const apiEndPoints = {
  signin: '/session',
  userCompanies: '/web_users/email_associated_companies',

  admin: {
    dailyLimits: '/admin/daily_limits',
    webControl: '/admin/web_control',
  },

  services: {
    downloadPaymentSlip: '/services/download_payment_slip',
  },

  user: {
    carrierDashboard: '/dashboard/home',
    ordersForCollect: '/order_collects/orders',

    ordersForSchedule: '/orders_for_schedule',
    collects: {
      root: '/collects',
      get destroySelected() {
        return `${this.root}/destroy_selected`
      },
      get count() {
        return `${this.root}/count`
      },
      get dateCheck() {
        return `${this.root}/date_check`
      },
      onMember(id) {
        return `${this.root}/${id}`
      },
    },

    orderCollects: {
      root: '/order_collects',
      update(idColeta) {
        return `${this.root}/${idColeta}`
      },
      cancel(idColeta) {
        return `${this.root}/${idColeta}/cancel`
      },
      reopen(idColeta) {
        return `${this.root}/${idColeta}/reopen`
      },
      get collectStatus() {
        return `${this.root}/status`
      },
    },
  },

  passwords: {
    root: '/passwords',
    onMember(id) {
      return `${this.root}/${id}`
    },
    updatePassword(token) {
      return `${this.root}/${token}`
    },
    get changePassword() {
      return `${this.root}/change_password`
    },
  },

  miscellaneous: {
    root: '/miscellaneous',
    get possibleDates() {
      return `/collects/possible_dates`
    },
    get truckTypes() {
      return `/miscellaneous/truck_types`
    },
    get carriers() {
      return '/miscellaneous/carriers'
    },
    get lastVehicles() {
      return '/services/vehicles'
    },
    get lastDrivers() {
      return '/services/drivers'
    },
    bulletins(status) {
      return `/bulletins/?status=${status}`
    },
    bulletinAttachments(bulletinId) {
      return `/bulletins/${bulletinId}/attachments`
    },
    readBulletin(bulletinId) {
      return `/bulletins/${bulletinId}/read`
    },
    get unreadedBulletins() {
      return `/bulletins/?status=1`
    },
  },

  invites: {
    root: '/web_invites',
    onMember(id) {
      return `${this.root}/${id}`
    },
    accept(id) {
      return `${this.onMember(id)}/accept`
    },
  },

  webCompanies: {
    root: '/web_companies',
    onMember(id) {
      return `${this.root}/${id}`
    },
    sendWebToken(id) {
      return `${this.onMember(id)}/resend_web_token`
    },
  },

  webUsers: {
    root: '/web_users',
    onMember(id) {
      return `${this.root}/${id}`
    },
    get changeUser() {
      return `/session/change_user`
    },
  },

  availableDates: {
    root: '/available_dates',
  },

  truckTypes: {
    root: '/truck_types',
  },

  reports: {
    rankingProdutos: '/reports/ranking_produtos',
    pedidosReservados: '/reports/pedidos_reservados',
    duplicatas: '/reports/duplicatas',
    comissoes: '/reports/comissoes',
    pedidosFaturados: '/reports/pedidos_faturados',
    estoque: '/reports/estoque',
  },
}

export default apiEndPoints
